import { chat as chatService } from '@shared/api/services';

export const chatApi = {
  postAttachment: (file) => chatService.postAttachment(file),
  createChat: (body) => chatService.createChat(body),
};
